import { NgModule } from '@angular/core';
import { EmitterService } from './services/emitter.service';
import { PrettyPhoneNumberPipe } from './pipes/pretty-phone-number.pipe';

@NgModule({
	imports: [],
	providers: [EmitterService],
	declarations: [PrettyPhoneNumberPipe],
	exports: [PrettyPhoneNumberPipe]
})
export class UtilityModule {}
